import React from "react";
import { useLocation } from "react-router-dom";
import NestedList from "../pages/biobank/dashboard/NestedList";
import logo from "assets/BiosciencesAndTechnology.svg";
import "styles/Sidebar.css";
import { useNavigation } from "../hooks/useNavigation";
import { getNavigationItems } from "../constants/navigation";
import { useAuth } from "./AuthProvider";

const AdminNavigation = () => {
  const navigationState = useNavigation();
  const { groups } = useAuth();
  const location = useLocation();

  // Get admin navigation items
  const { main: navItems, bottom: bottomNavItems } = getNavigationItems(
    groups,
    location.pathname
  );

  return (
    <aside className="sidebar">
      <div style={{ margin: "25px 15px 25px 15px" }}>
        <img
          src={logo}
          alt="Logo"
          className="logo-image"
          style={{
            margin: "0",
            width: "174px",
            height: "auto",
            display: "block",
          }}
        />
      </div>
      <nav
        className="sidebar-nav"
        role="navigation"
        aria-label="Admin navigation"
      >
        <NestedList items={navItems} navigationState={navigationState} />
      </nav>
      <nav
        className="sidebar-bottom"
        role="navigation"
        aria-label="Admin user actions"
      >
        <NestedList items={bottomNavItems} navigationState={navigationState} />
      </nav>
    </aside>
  );
};

export default AdminNavigation;
